export const earn = {
    jdzb: "간편하게 돈 벌기",
    jryd: "금융의 길, 함께 나아가기",
    jrbk: "Biking에 가입하여 간편하게 돈을 벌고, 혁신적으로 귀하의 디지털 자산을 최대 수익으로 확대합니다",
    zbz: "돈 벌기 중",
    ljsy: "누적 수익",
    zrsy: "어제의 수익",
    hq: "당좌",
    dq: "정기",
    cknh: "참고 연환",
    sqjd: "신청 진행률",
    sg: "신청",
    qbcp: "전체 제품",
    cz: "재설정",
    qx: "기간",
    question1: "1. 돈 벌기란 무엇인가요?",
    question1_text: "돈 벌기는 BIKING이 다양한 코인 보유 기회를 발견하는 데 도움을 주는 종합 서비스 플랫폼입니다. 현재 간편하게 돈 벌기인 잉여 코인 보관함(사용 즉시 인출)을 출시했으며, 향후 더 많은 제품을 출시하여 사용자에게 다양한 제품 선택을 제공할 예정입니다.",
    question2: "2. 참고 연환이란 무엇인가요?",
    question2_text: "돈 벌기 수익은 현재 보유 코인에 대한 이자입니다. 참고 연환은 보유 코인에 대한 이자 연환입니다. 예를 들어, 제품 A의 최초 1000U에 대해 12%의 참고 연환을 적용하고, 1000U를 초과하면 2%의 참고 연환을 적용하면 총 참고 이자 연환율은 14%입니다.",
    question3: "3. 언제 이자가 시작되고 종료되나요?",
    question3_text: "다양한 제품을 신청할 때 이자가 시작되고 종료되는 시간은 다를 수 있습니다. 현재 USDT의 시중 가치의 간편한 돈 벌기를 예로 들어보겠습니다. USDT 당일 현금 기반 제품의 경우, 제품을 신청한 다음 날 새벽 2시에 시작됩니다(UTC+8). 이자는 신청 후 1일 후(즉, 신청 시간 T+2)에 새벽 5시(UTC+8)에 지급되며, 이는 전일 이자가 결산되는 시간입니다.",
    question4: "4. 남은 투자 가능 금액이란 무엇인가요?",
    question4_text: "남은 투자 가능 금액은 여러분이 해당 금융 제품을 신청할 수 있는 금액입니다.<br/>남은 투자 가능 금액 = 총 제품 구매 한도 - 여러분이 이미 신청한 금액",
    xzmbfs: "코인/코인 구매 방법 선택",
    nhsyl: "연환 수익률 및 기간:",
    sl: "수량",
    qitou: "최소 투자",
    max: "최대",
    kzcsl: "이것은 계정에서 인출할 수 있는 금액입니다.",
    sykt: "남은 투자 가능",
    syktsl: "남은 투자 가능은 여러분이 신청할 수 있는 금액입니다.",
    syktsx: "남은 투자 가능 = 총 제품 구매 한도 - 여러분이 이미 신청한 금액(개인 투자 한도 {amount}{coin} 이하)",
    jlgz: "보상 규정",
    jd1: "1단계: 최초 {amount}{coin}",
    ptjl: "플랫폼 보상",
    jd2: "2단계: 최초 {amount}{coin} 이상",
    grsgsx: "개인 신청 한도는 {amount}{coin} 입니다",
    gz: "규정",
    sgsj: "신청 시간",
    xianzai: "현재",
    qxsj: "이자 시작 시간",
    lxrz: "이자 지급",
    c2c: "C2C 코인 구매",
    lhxz: "유연한 선택, 더 좋은 가격",
    lcjd: "단순한 프로세스, 빠른 거래",
    crszhb: "지갑이나 거래소에서 디지털 자산을 입금하세요.",
    zcsl: "자산 수량",
    dzsy: "예상 수익",
    lcxx: "금융 정보",
    zt: "상태",
    sh: "상환",
    sgje: "신청 금액",
    sgzj: "신청 자금의 최초 {amount}{coin}은 {value}% 보너스 연환을 받을 수 있습니다",
    dyklqje: "{amount}{coin} 이상은 {value}% 보너스 연환을 받을 수 있습니다",
    grsged: "개인 신청 한도는 {amount}부터 {amount2}{coin}까지입니다.",
    shsl: "상환 수량",
    srshsl: "상환할 수량 입력",
    ksh: "상환 가능:",
    haode: "알겠습니다",
    sgcg: "신청 성공",
    shcg: "상환 성공",
    zcsg: "다시 신청",
    sjdzsl: "실제 입금 수량",
    shsj: "상환 시간",
    jssj: "결산 시간",
    yjsdd: "결산된 주문",
    jyjl: "거래 기록",
    hqjdzb: "당좌 간편 돈 벌기",
    sy: "수익",
    wwc: "미완료",
    xmlx: "프로젝트 유형",
    hqjdzbcp: "당좌 간편 돈 벌기는 Biking이 제공하는 안전한 금융 제품으로, 24시간 언제든지 인출할 수 있으며 시간당 이자가 적용됩니다.",
    nh: "연환",
    zhzchz: "계정 자산 상호 이체, 간단하고 빠르게",
    qsrsl: "수량을 입력하세요",
    yjssymx: "결산된 수익 내역",
    mx: "내역",
    qwsmrz: "실명인증으로 이동",
    jxwcsmrz: "1. 이 활동은 실명 인증을 완료한 사용자에게만 제공됩니다. 각 사용자는 이 활동에 한 번만 참여할 수 있습니다.",
    dqcked: "2. 각 사용자의 정기 예금 금액은 {min}~{max}{coin}이며, 만기 시 시스템에서 자동으로 계좌로 상환됩니다.",
    cpbntjsh: "3. 이 상품은 사전 교환이 불가능합니다.",
    anzh: "4. 제품 구독 후 총 풀은 0이 되고 버튼은 회색으로 표시됩니다.",
    smrzyh: "이 활동은 실명 인증을 완료한 사용자에게만 제공됩니다.",
    jxcjyc: "적격 사용자는 한 번만 참여할 수 있습니다",
    ygsy: "예상 수익",
    scqx: "잠금 기간",
    qixian: "{min}일째 (총 {max}일)",
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/kr.js